import { useState } from "react";
import { navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = () => {
    setKeyword("");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">51cg5</span>
            <span className="font-label text-[10px] font-medium tracking-[0.22em] text-foreground-500">HOT TRACKER</span>
          </span>
        </a>

        <nav className="ml-3 hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <div className="hidden items-center rounded-full border border-background-300/70 bg-background-100 py-1 pl-3 pr-1 md:flex">
            <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索话题 / 榜单"
              className="w-32 bg-transparent px-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 lg:w-44"
            />
            <button
              type="button"
              onClick={handleSearch}
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </div>

          <button
            type="button"
            className="hidden cursor-pointer whitespace-nowrap rounded-md border border-primary-300 bg-primary-100 px-4 py-2 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-200 md:inline-flex"
          >
            登录
          </button>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-700 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <div className="mx-auto max-w-[1440px] px-4 py-4 md:px-6">
            <div className="mb-3 flex items-center rounded-full border border-background-300/70 bg-background-100 py-1 pl-3 pr-1">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                placeholder="搜索话题 / 榜单"
                className="w-full bg-transparent px-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50"
              >
                搜索
              </button>
            </div>
            <nav className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <button
              type="button"
              className="mt-3 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              登录 / 注册
            </button>
          </div>
        </div>
      ) : null}
    </header>
  );
}